<router-loading [matchUrl]="activatedUrl" class="root-outlet">
    <router-outlet></router-outlet>
</router-loading>
